/**
 * scan-to-cart — skaner kodini savatga qo'shish (global skaner + kassa qutisi
 * birgalikda ishlatadi). scanByCode (server exact match) → savatga qo'shadi.
 */
import { buildVariantLabel } from '@avtofix/shared';

import { toast } from '@/shared/ui/toast';
import { productsApi } from '@/features/products/products.api';

import { useCartStore, type AddItemVariantInfo } from './cart.store';

/** Bitta kodni skanerlab savatga qo'shadi. Topilib qo'shilsa true. */
export async function scanAndAddToCart(code: string): Promise<boolean> {
  const c = code.trim();
  if (c === '') return false;
  let result;
  try {
    result = await productsApi.scanByCode(c);
  } catch {
    return false;
  }
  if (!result.found) return false;
  const variantInfo: AddItemVariantInfo | undefined =
    result.type === 'variant'
      ? { variantIndex: result.variantIndex, variant: result.variant }
      : undefined;
  const stock = variantInfo?.variant.stock ?? result.product.stock;
  const label =
    variantInfo !== undefined ? buildVariantLabel(variantInfo.variant) : result.product.name;
  // Backorder: stok 0/manfiy bo'lsa ham savatga qo'shamiz (egasi talabi — zaxira
  // aniq emas/sanab ulgurmagan). Faqat ogohlantiramiz, bloklamaymiz.
  useCartStore.getState().addItem(result.product, 1, variantInfo);
  if (stock <= 0) {
    toast.warning(`+ ${label} — omborda yo'q (backorder)`);
  } else {
    toast.success(`+ ${label}`);
  }
  return true;
}

/**
 * Skaner kiritmasini qayta ishlash:
 *   1. Butun kod (8-belgili parent yoki 10-belgili variant).
 *   2. Topilmasa va 8 ga karrali (≥16) alfanumerik — Enter'siz skaner bir necha
 *      8-belgili kodni ketma-ket yuborgan → 8 belgidan bo'lib har birini qo'shadi.
 * Biror mahsulot qo'shilsa true.
 */
export async function processScanCodes(raw: string): Promise<boolean> {
  const code = raw.trim();
  if (code === '') return false;
  if (await scanAndAddToCart(code)) return true;
  if (/^[A-Za-z0-9]+$/.test(code) && code.length >= 16 && code.length % 8 === 0) {
    let any = false;
    for (let i = 0; i < code.length; i += 8) {
      if (await scanAndAddToCart(code.slice(i, i + 8))) any = true;
    }
    return any;
  }
  return false;
}
